import { z } from 'zod';

const preferredWorkerOptionSchema = z.object({
  workerId: z.string(),
  firstName: z.string(),
  infix: z.string().nullable(),
  lastName: z.string(),
  employmentType: z.enum(['FREELANCER', 'TEMPWORKER', 'EMPLOYEE']),
  companyName: z.string().nullable(),
  workerType: z.enum(['PLATFORM', 'PARTNER']),
});

export const preferredWorkerOptionsSchema = z.array(preferredWorkerOptionSchema);

export type PreferredWorkerOptions = z.infer<typeof preferredWorkerOptionsSchema>;
